// components/auth/AuthHeader.jsx
import LogoImg from "../../images/goelectronixB.png";

export default function AuthHeader({ title, subtitle }) {
  return (
    <div className="text-center mb-6">
      {/* <img src={LogoImg} alt="Logo" className="mx-auto h-12 mb-2" /> */}
      <h1 className="text-2xl font-semibold text-slate-800">{title}</h1>
      {subtitle && (
        <p className="text-sm text-slate-600">{subtitle}</p>
      )}
    </div>
  );
}
